export default __webpack_public_path__ + "static/media/magiccat.8edea9df.gif";